import BrandsValueOverviewDashboard, {
  WIDGET_IDS,
} from "~/ui-rtk/components/features/dashboards/BrandValueOverviewDashboard/BrandValueOverviewDashboard"
import useConnect from "./connect"
import WithLoader from "~/ui-rtk/components/layout/WithLoader/WithLoader"
import useReconnectSourcesBanner from "~/ui-rtk/hooks/reconnect-sources-banner"
import { useEffect } from "react"
import ReconnectBanner from "~/ui-rtk/components/layout/ReconnectBanner/ReconnectBanner"
import useRequiredSourcesByWidgetIds from "~/ui-rtk/hooks/required-sources"

export default function BrandsValueOverview() {
  const { content, toggleAmazon, amazonEnabled, isLoading, cubeQueryParams } =
    useConnect()

  const requiredSources = useRequiredSourcesByWidgetIds(WIDGET_IDS)

  const { connectorsToReconnect, setRequiredSources } =
    useReconnectSourcesBanner()

  useEffect(() => {
    setRequiredSources(requiredSources)
  }, [requiredSources])

  return (
    <div className="h-full px-system-lg py-system-lg bg-basic-black text-basic-light">
      <WithLoader isLoading={isLoading}>
        <ReconnectBanner connectors={connectorsToReconnect} />
        <BrandsValueOverviewDashboard
          slug={content.slug}
          title={content.title}
          toggleAmazon={toggleAmazon}
          amazonEnabled={amazonEnabled}
          props={{
            commonGranularityPicker: true,
          }}
          parent={content.parent}
          cubeQueryParams={cubeQueryParams}
        />
      </WithLoader>
    </div>
  )
}
